// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, Handler } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import { chain, DispatchSetUserFields ,ValidateFields} from "@insite/client-framework/Store/Pages/UserSetup/Handlers/SetUserFields";
import translate from "@insite/client-framework/Translate";
import { xRegex } from "@keller/XDL/Utilities";

type HandlerType = Handler<{
    phone?: string;
},
{
    phoneErrorMessage?: string;
}>;

export const ValidatePhone: HandlerType = props => {
    const {
        parameter: { phone },
    } = props;
    if (typeof phone === "undefined") {
        return;
    }

    const requiredFieldMessage = siteMessage("Field_Required", translate("Phone Number"));
    const phoneFieldMessage = siteMessage("Field_Invalid", translate("Phone Number"));

    const errorMessage = phone === "" ? requiredFieldMessage : xRegex.phone.test(phone) ? "" : phoneFieldMessage;
    props.phoneErrorMessage = errorMessage as string;
};

export const DispatchUpdatePhoneNumber: HandlerType = props => {
    const {
        parameter: { phone },
    } = props;
    if (typeof phone === "undefined") {
        return;
    }
    props.dispatch({
        type: "xUserSetup/SetPhoneNumber",
        phoneErrorMessage: props.phoneErrorMessage,
        phone,
    } as any);
};

addToChainAfter(chain , ValidateFields , ValidatePhone as any);
addToChainAfter(chain , DispatchSetUserFields , DispatchUpdatePhoneNumber as any);

